import React from "react";

/**
 * Full-page state placeholder for loading, empty, and error states.
 */
/**
 * JSDoc-Typen für TypeScript-Consumer — ohne sie leitet tsc aus dem
 * Destructuring Pflicht-Props ab und TSX-Aufrufer scheitern am Typecheck.
 *
 * @param {{
 *   icon?: React.ReactNode,
 *   title?: React.ReactNode,
 *   description?: React.ReactNode,
 *   action?: React.ReactNode,
 *   children?: React.ReactNode,
 * }} props
 */
export function PageState({ icon, title, description, action, children }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      {icon && (
        <div className="w-16 h-16 rounded-xl bg-surface-container-highest flex items-center justify-center text-on-surface-variant mb-6">
          <span className="material-symbols-outlined text-4xl" aria-hidden="true">
            {icon}
          </span>
        </div>
      )}
      {title && <h2 className="text-2xl font-bold font-headline text-on-surface mb-2">{title}</h2>}
      {description && (
        <p className="text-on-surface-variant text-sm max-w-md mb-6">{description}</p>
      )}
      {action}
      {children}
    </div>
  );
}

/**
 * Skeleton loading placeholder with pulse animation.
 */
export function Skeleton({ className = "", rounded = "rounded-lg" }) {
  return (
    <div
      className={`bg-surface-container-highest animate-pulse motion-reduce:animate-none ${rounded} ${className}`}
    />
  );
}

/**
 * Progress bar with optional label.
 */
export function ProgressBar({ value = 0, color = "tertiary", className = "" }) {
  const colorMap = {
    primary: "bg-primary",
    secondary: "bg-secondary",
    tertiary: "bg-tertiary",
    success: "bg-success",
    warning: "bg-warning",
    error: "bg-error",
  };

  return (
    <div className={`w-full bg-on-surface/[.08] h-1 rounded-full overflow-hidden ${className}`}>
      <div
        className={`${colorMap[color] || colorMap.tertiary} h-full w-full origin-left transition-transform duration-300 motion-reduce:transition-none`}
        style={{ transform: `scaleX(${Math.min(100, Math.max(0, value)) / 100})` }}
      />
    </div>
  );
}
